<template>
  <div :class="['p-search-input', { 'p-search-input--hide-cancel': props.hideCancel }]">
    <SearchInput
      v-bind="$attrs"
      :model-value="modelValue == null ? undefined : String(modelValue)"
      :size="resolvedSize"
      :placeholder="props.placeholder ?? ''"
      :right-action="false"
      :cancel-text="$t('general.cancel')"
      @update:model-value="onUpdateValue"
      @clear="$emit('on-clear')"
      @cancel="$emit('on-close')"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import _ from 'lodash'
import { SearchInput } from '@p-utilities/vue'

const emit = defineEmits([
  'on-blur',
  'on-close',
  'on-focus',
  'on-debounce',
  'on-clear',
  'update:modelValue',
])

const modelValue = defineModel<string | number>('modelValue')

const props = defineProps<{
  placeholder?: string
  showClose?: boolean
  debounceDelay?: number
  size?: 'sm' | 'md' | 'lg' | 'medium' | 'large'
  hideCancel?: boolean
}>()

const SIZE_MAP: Record<string, 'medium' | 'large'> = {
  sm: 'medium',
  md: 'medium',
  lg: 'large',
}
const resolvedSize = computed<'medium' | 'large'>(() => {
  const s = props.size
  if (!s) return 'medium'
  if (s === 'medium' || s === 'large') return s
  return SIZE_MAP[s] ?? 'medium'
})

// debounceDelay is captured at setup; changing it dynamically post-mount
// won't update the interval. No current call site changes it dynamically;
// extend with a watch if that requirement appears.
const debounced = _.debounce(() => emit('on-debounce'), props.debounceDelay ?? 500)

const onUpdateValue = (v: string) => {
  modelValue.value = v
  debounced()
}
</script>

<style lang="scss" scoped>
.p-search-input {
  display: flex;
  flex-grow: 1;

  &--hide-cancel :deep(.p26-search-input__cancel) {
    display: none !important;
  }
}
</style>
